import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Components
import FormInput from '../../components/Global/Forms/FormInput';
import MaskedFormInput from '../../components/Global/Forms/MaskedFormInput';
import SplitInputContainer from '../../components/Global/Forms/SplitInputContainer';
import AppCanvasLoader from '../../components/Global/AppCanvasLoader';

// Utils
import {
  isValidPhoneNumber,
} from '../../utils/helpers';

class AccountInfoForm extends Component {

  state = {
    input: {
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
      password: '',
    },
    formErrors: {
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
      password: '',
    },
    displayErrorMessages: false,
    formIsValid: false,
    isLoading: false,
  }

  componentDidMount() {
    this.setStateFromProps(this.props);
  }

  setStateFromProps(props) {
    const { user } = props;

    this.setState(state => ({
      ...state,
      input: {
        first_name: user.first_name,
        last_name: user.last_name,
        phone_number: user.phone_number,
        email: user.email,
        password: 'placeholder',
      },
      isLoading: false
    }))
  }

  handleInputChange = (event) => {
    const { value, name } = event.target;

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        [name]: value
      }
    }), () => { this.updateFieldErrorMessage(name, value) });
  }

  handleEmailInputBlur = (event) => {
    const { value, name } = event.target;
    const { formIsValid, displayErrorMessages } = this.state;

    this.updateFieldErrorMessage(name, value);

    if (!formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { input } = this.state;

    if (this.isFormValid()) {
      this.props.handleSubmit(input);
    } else {
      this.setFormErrorState();
    }
  }

  setFormErrorState = () => {
    const { input, displayErrorMessages } = this.state;

    Object.keys(input).map((field, i) => {
      return this.updateFieldErrorMessage(field, input[field])
    })

    if (!this.state.formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  turnOnErrorMessages() {
    this.setState(state => ({
      ...state,
      displayErrorMessages: true
    }));
  }

  toggleErrorMessages() {
    const { displayErrorMessages } = this.state;

    this.setState(state => ({
      ...state,
      displayErrorMessages: !displayErrorMessages
    }));
  }

  updateFieldErrorMessage = (fieldName, value) => {
    let formErrors = this.state.formErrors;

    switch(fieldName) {
      case 'phone_number':
        formErrors[fieldName] = isValidPhoneNumber(value)
        ? ''
        : 'Please enter a valid phone number'
        break;
      default:
        formErrors[fieldName] = value.length > 0
          ? ''
          : 'Please complete this field';
        break;
    }

    this.setState(state => ({
      ...state,
      formErrors,
    }));
  }

  isFormValid() {
    const { input } = this.state;

    let inputErrorIndex = Object.keys(input).map((field, i) => {
      return this.isFieldValid(field, input[field])
    }).indexOf(false)

    if (inputErrorIndex > -1) {
      return false;
    } else {
      return true;
    }
  }

  isFieldValid = (fieldName, value) => {
    switch(fieldName) {
      case 'phone_number':
        return isValidPhoneNumber(value)
      default:
        return value.length > 0
        // eslint-disable-next-line no-unreachable
        break;
    }
  }

  render() {
    const {
      input,
      formErrors,
      displayErrorMessages,
      isLoading,
    } = this.state;

    const { submitButtonText } = this.props;

    return isLoading
    ? (
      <AppCanvasLoader />
    )
    : (
      <form
        onSubmit={this.handleSubmit}
        className="account-info-form"
      >
        <SplitInputContainer
          showErrors={displayErrorMessages}
          errorMessages={[formErrors.athlete_first_name, formErrors.athlete_last_name]}
        >
          <FormInput
            label="First Name"
            placeholder="First Name"
            name="first_name"
            type="text"
            value={input.first_name}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.first_name}
          />
          <FormInput
            label="Last Name"
            placeholder="Last Name"
            name="last_name"
            type="text"
            value={input.last_name}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.last_name}
          />
        </SplitInputContainer>
        <MaskedFormInput
          label="Phone Number"
          name="phone_number"
          mask={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
          placeholder="(555) 555-5555"
          placeholderChar={'\u2000'}
          guide={true}
          type="tel"
          value={input.phone_number.toString()}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.phone_number}
        />
        <FormInput
          label="Email Address"
          placeholder="Email Address"
          name="email"
          type="text"
          value={input.email}
          onChange={this.handleInputChange}
          onBlur={this.handleEmailInputBlur}
          showError={displayErrorMessages}
          errorMessage={formErrors.email}
          disabled={true}
        />
        <FormInput
          label="Password"
          placeholder="Password"
          name="password"
          type="password"
          value={input.password}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.password}
          disabled={true}
          optionalClasses="password-input"
        />
        <Link
          to="/reset-password"
          className="text-link reset-password-link"
          target="_blank"
        >
          Reset Password
        </Link>
        <hr/>
        <input
          type="submit"
          className="cta-gradient"
          value={submitButtonText ? submitButtonText : 'Submit'}
          onClick={this.handleSubmit}
        />
      </form>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    accountDetails: state.accountDetails
  }
}

// const mapDispatchToProps = dispatch => {
//   return {
//     updateOnboardingForm: formData => {
//       dispatch(updateForm(formData))
//     },
//   }
// }

export default connect(
  mapStateToProps,
  null
)(AccountInfoForm)



// WEBPACK FOOTER //
// ./src/components/Forms/AccountInfoForm.js